import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Award, Flame, ShieldCheck } from "lucide-react";
import { contact, products } from "../mock";

export default function Footer() {
  return (
    <footer>
      {/* Orange certifications strip */}
      <div className="bg-orange-500 text-white">
        <div className="max-w-7xl mx-auto px-6 py-7 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { label: "ISO 9001:2015", icon: Award },
            { label: "RoHS Compliant", icon: Flame },
            { label: "CE MARKED", icon: ShieldCheck },
            { label: "MSME Registered", icon: Award },
          ].map((c, i) => {
            const Icon = c.icon;
            return (
              <div key={i} className="flex items-center gap-3 justify-center md:justify-start">
                <span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center">
                  <Icon size={18} />
                </span>
                <span className="font-semibold tracking-wider uppercase text-sm md:text-base">{c.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Main footer */}
      <div className="bg-neutral-900 text-neutral-300 bg-dotted-dark">
        <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <p className="text-[10px] tracking-[0.2em] text-orange-500 font-semibold mb-2">AN ISO 9001:2015 CERTIFIED COMPANY</p>
            <h3 className="font-display text-2xl text-white">
              ESS BEE HEATERS
              <br />
              <span className="text-orange-500">PVT. LTD.</span>
            </h3>
            <span className="block h-[3px] w-12 bg-orange-500 mt-3 mb-5" />
            <p className="text-sm leading-relaxed text-neutral-400">
              Leading manufacturer of industrial heaters &amp; heating elements with 25+ years of engineering excellence.
            </p>
            <p className="mt-5 text-sm text-neutral-300">
              <span className="inline-block w-2 h-2 rounded-full bg-orange-500 align-middle mr-2" />
              Trusted by 1000+ clients across India
            </p>
          </div>

          <div>
            <h4 className="flex items-center gap-3 font-display text-lg text-white uppercase">
              <span className="w-8 h-[2px] bg-orange-500" /> Quick Links
            </h4>
            <ul className="mt-6 space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/products", label: "Products" },
                { to: "/contact", label: "Contact" },
              ].map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="hover:text-orange-400 transition-colors">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-3 font-display text-lg text-white uppercase">
              <span className="w-8 h-[2px] bg-orange-500" /> Products
            </h4>
            <ul className="mt-6 space-y-3 text-sm">
              {products.map(p => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`} className="hover:text-orange-400 transition-colors">{p.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-3 font-display text-lg text-white uppercase">
              <span className="w-8 h-[2px] bg-orange-500" /> Reach Us
            </h4>
            <ul className="mt-6 space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-orange-500 mt-1" />
                <a href={`tel:${contact.phone}`} className="hover:text-orange-400">{contact.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-orange-500 mt-1" />
                <div className="space-y-1">
                  {contact.emails.map(e => (
                    <a key={e} href={`mailto:${e}`} className="block hover:text-orange-400 break-all">{e}</a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-orange-500 mt-1" />
                <span>{contact.location}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-orange-500 mt-1" />
                <span>{contact.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-neutral-800">
          <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-500">
            <p>© {new Date().getFullYear()} <span className="text-orange-500 font-semibold">Ess Bee Heaters Pvt. Ltd.</span> All rights reserved.</p>
            <p className="tracking-wider text-center md:text-right">
              <span className="text-neutral-400">All Designs Are Made &amp; Think By</span>{" "}
              <span className="text-orange-500 font-bold uppercase tracking-widest">Hrithik Bansal</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
